import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFSMBusinessObj, IGetAllFSMList } from '../../actions/types/sources/GetFSMListTypes';

/**
 * Initial All Source Event Registry state in store
 */
const initialState: IGetAllFSMList = {
  isLoading: false,
  listFSMErrorMessage: '',
  businessObjects: {
    item: 0,
    currentPageNumber: 0,
    numberOfRecordsPerPage: 10,
    totalRecords: 0,
    numberOfPages: 0,
    businessObjects: []
  }
};

const fetchFSMBusinessListSlice = createSlice({
  name: 'fetchFSMBusinessList',
  initialState,
  reducers: {
    fetchFSMBusinessListStarted: (state) => {
      state.isLoading = true;
    },

    fetchFSMBusinessListSuccess: (
      state,
      action: PayloadAction<IFSMBusinessObj>
    ) => {
      state.isLoading = false;
      state.businessObjects = action.payload;
      state.listFSMErrorMessage = '';
    },

    fetchFSMBusinessListFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.businessObjects = initialState.businessObjects;
      state.listFSMErrorMessage = action.payload;
    },

    clearFSMBusinessListDetails: (state) => {
      state.isLoading = false;
      state.businessObjects = initialState.businessObjects;
      state.listFSMErrorMessage = '';
    }
  }
});
export const {
  fetchFSMBusinessListStarted,
  fetchFSMBusinessListSuccess,
  fetchFSMBusinessListFail,
  clearFSMBusinessListDetails
} = fetchFSMBusinessListSlice.actions;
export default fetchFSMBusinessListSlice.reducer;
